module.exports = __webpack_public_path__ + "img/ES 18.jpg";